import * as React from "react";
import {Option} from "ts-option";
import Price from "../../../model/common/Price";
import "../../accounting/common/commonDetailsInfoRow.scss";

interface IProps {
	/**
	 * Customer price to display
	 */
	customerPrice: Option<Price>
	/**
	 * Installer earnings to display
	 */
	installerEarnings: Option<Price>
}

export default class BillOfMaterialsPrices extends React.PureComponent<IProps> {
	render() {
		return (
			<>
				{this.props.customerPrice.isDefined && this.props.installerEarnings.isDefined &&
				<>
					<div className="c-common-info_row-item">
						<div className="c-common-info_row-item_value-large">{this.props.customerPrice.get.format()}</div>
						<div className="c-common-info_row-item_label-bottom">Customer price</div>
					</div>
					<div className="c-common-info_row-item">
						<div className="c-common-info_row-item_value-large">{this.props.installerEarnings.get.format()}</div>
						<div className="c-common-info_row-item_label-bottom">Installer earnings</div>
					</div>
				</>
				}
			</>
		);
	}
}
